import React, { useState, useEffect, useRef } from 'react';
import Dropdown from "../dropdown/index";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import profile from '../public/ProfileCircle-Bold-32px.png';
import axios from 'axios';

const Navbar = ({ onOpenSidenav, brandText }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [lsat, setLsat] = useState(localStorage.getItem("authUser") || "");
  const [userImage, setUserImage] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      if (!localStorage.getItem("authUser")) {
        navigate('/');
        return;
      }
      const data = JSON.parse(localStorage.getItem("authUser"));
      setUser(data);
      setLsat(localStorage.getItem("authUser"));
      fetchUserImage(data);
    };
    fetchUserData();
    // Close dropdown on outside click
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line
  }, [navigate]);

  // Fetch user image
  const fetchUserImage = async (userData) => {
    try {
      if (!userData?.username) return;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${lsat}`,
        }
      };
      const response = await axios.get(
        `https://portal-sanieldanproperties-api.onrender.com/dashboard/user/image/${userData._id}`,
        config
      );
      if (response.status === 200) setUserImage(response.data.image);
    } catch (error) {
      // fallback to default image
    }
  };

  // Logout
  const logoutHandler = () => {
    localStorage.removeItem('authUser');
    navigate("/");
  };

  // Dropdown toggle
  const handleDropdownToggle = () => setDropdownOpen((prev) => !prev);

  return (
    <nav className=" top-4 z-40 flex flex-row items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      {/* Brand */}
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 dark:text-white">/</span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      {/* Right section */}
      <div className="relative flex h-[61px] items-center gap-4 rounded bg-white px-2 py-2 shadow-xl dark:bg-navy-800 max-sm:w-full">
        {/* Sidenav Toggle */}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>

        {/* Profile Dropdown */}
        <div className="relative flex items-center" ref={dropdownRef}>
          <button
            className="flex items-center gap-1 focus:outline-none"
            onClick={handleDropdownToggle}
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
          >
            <img
              src={userImage || profile}
              alt="user"
              className="w-10 h-10 rounded-full border-2 border-gray-200"
            />
            {dropdownOpen ? (
              <BsChevronUp className="ml-1 text-gray-600 dark:text-white" />
            ) : (
              <BsChevronDown className="ml-1 text-gray-600 dark:text-white" />
            )}
          </button>
          {/* Dropdown Content */}
          {dropdownOpen && (
            <div className="absolute right-0 top-12 w-56 flex flex-col rounded-[20px] bg-white shadow-xl dark:bg-navy-700 dark:text-white z-50">
              <div className="p-4 border-b border-gray-200 dark:border-white/20">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {user.username || 'User'}
                  </p>
                </div>
              </div>
              <div className="flex flex-col p-4">
                <button
                  onClick={logoutHandler}
                  className="text-sm font-medium text-red-500 hover:text-red-600 transition"
                >
                  Log Out
                </button>
              </div>
            </div>
          )}
        </div>

        {/* User Info */}
        <div className="flex flex-col items-start ml-3">
          <span className="font-semibold text-navy-700 dark:text-white">
            {user.firstName} {user.lastName}
          </span>
          <span className="text-xs underline text-gray-500 dark:text-gray-300">
            {user.email}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
